import {DocumentSummaryModel} from './documentSummary.model';
import {DocumentSignatureModel} from "../../../signature/api/model/documentSignature.model";

export class DocumentModel {
    summary: DocumentSummaryModel;
    signature: DocumentSignatureModel;
}
